


















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'TriggerSummary',
    props: {
        summary: {
            type: Array,
            required: true,
        },
    },
});
